import { oz } from '@weft/utils';
import { NewLineItemProductCommitmentSchema } from './new-line-item-product-commitment-schema';

export const LineItemProductCommitmentInputSchema = oz.object(NewLineItemProductCommitmentSchema.shape)
  .partial()
  .openapi('LineItemProductCommitmentInput');

export type LineItemProductCommitmentInput = oz.infer<typeof LineItemProductCommitmentInputSchema>;